export default __webpack_public_path__ + "static/media/faq_man.5ffd8d24.png";